export { Card } from "@mantine/core";
export type { CardProps } from "@mantine/core";
export { cardOverrides } from "./Card.config";
